<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      {{ this.$string.sidebar.menu_6.sub_menu.menu_1 }}      
      <CButton
        color="danger"
        style="float:right;margin-right:10px"
        class="btn-md ml-auto"
      >Ekspor PDF</CButton>
      <CDropdown
        toggler-text="Ekspor Excel"
        color="warning"
        class="mr-2 d-inline-block text-white float-right"
      >
        <CDropdownItem>Ekspor Semua</CDropdownItem>
        <CDropdownItem>Ekspor Beberapa Data</CDropdownItem>
      </CDropdown>
      <router-link to="/finance/sales-order/tambah">
        <CButton color="success" style="float:right;margin-right:10px" class="btn-md">Tambah</CButton>
      </router-link>
    </CCardHeader>
    <!-- Data Sales Order -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id>
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" placeholder="Cari Data ..." />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{ index}">
              <td class="py-2">{{ index+1 }}</td>
            </template>
            <template #nominal="{item}">
              <td class="py-2">{{ 'Rp.'+item.nominal }}</td>
            </template>
            <template #no_anggota="{item}">
              <td class="py-2">{{ item.no_anggota ? item.no_anggota : "-" }}</td>
            </template>
            <template #nama_item="{item}">
              <td class="py-2">{{ item.nama_item ? item.nama_item : "-" }}</td>
            </template>
            <template #status_pembayaran="{item}">
              <td class="py-2">
                <span
                  class="font-weight-bold text-success"
                  v-if="item.status_pembayaran   == 'settlement'"
                >
                  Lunas
                </span>
                <span
                  class="font-weight-bold text-success"
                  v-else-if="item.status_pembayaran   == 'pending'"
                >
                  Menunggu Pembayaran
                </span>
                <span
                  class="font-weight-bold text-warning"
                  v-else-if="item.status_pembayaran   == 'expire'"
                >
                  Expired
                </span>
                <span
                  class="font-weight-bold text-danger"
                  v-else-if="item.status_pembayaran   == 'failure'"
                >
                  Pembayaran Gagal
                </span>
                <span class="font-weight-bold text-danger" v-else>
                  Dibatalkan
                </span>
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <router-link to="/finance/sales-order/edit">
                  <CButton color="info" class="btn-sm text-white mr-1" square>
                    <font-awesome-icon icon="edit" />
                  </CButton>
                </router-link>&nbsp;&nbsp;
                <CButton color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Nama Lengkap" placeholder="Masukkan Nama" />
            </CCol>
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Email" placeholder="Masukkan Email" />
            </CCol>
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Kantor" placeholder="Masukkan Nama Kantor" />
            </CCol>
            <CCol sm="12">
              <CInput
                class="font-weight-bold"
                label="TIpe Keanggotaan"
                placeholder="Pilih Tipe Keanggotaan"
              />
            </CCol>
            <CCol sm="12">
              <CInput
                class="font-weight-bold"
                label="Nomor Anggota"
                placeholder="Masukkan Nomor Anggota"
              />
            </CCol>
            <CCol sm="12">
              <CInput
                class="font-weight-bold"
                label="Nomor Unik"
                placeholder="Masukkan Nomor Unik"
              />
            </CCol>

            <CCol sm="12">
              <CInput class="font-weight-bold" label="Invoice" placeholder="Masukkan Invoice" />
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Orders</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="ya"
                    checked
                  />
                  <label class="custom-control-label" for="ya">Ya</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" class="custom-control-input" name="customRadio" id="tidak" />
                  <label class="custom-control-label" for="tidak">Tidak</label>
                </div>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Tambah</h6>          
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->

      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="modalInvoice"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CCol sm="12"></CCol>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail Invoice</h6>
          <CButtonClose @click="modalInvoice = false" class="text-danger" />
        </template>
        <template #footer>
          <CButton @click="modalInvoice = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data Sales Order -->
  </CCard>
</template>
<script>
import SalesOrderService from "../../services/finance/sales-order.service";

const fields = [
  {
    key: "no",
    label: "No",
    sorter: false,
    filter: false
  },
  {
    key: "no_anggota",
    label: "No Anggota",
    sorter: false,
    filter: false
  },
  {
    key: "id_invoice",
    label: "No Tagihan",
    sorter: false,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: false,
    filter: false
  },

  {
    key: "email",
    label: "Email",
    sorter: false,
    filter: false
  },{
    key: "nominal",
    label: "Nominal",
    sorter: false,
    filter: false
  },
  {
    key: "nama_item",
    label: "Item",
    sorter: false,
    filter: false
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 12%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {  
  data() {
    return {
      items: [],
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Pilih File",
      fields,
      status: "",
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      modalInvoice: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  mounted() {
    this.getData();
    // alert("Sales Order")
  },
  methods: {
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getData() {
      var vm = this;
      SalesOrderService.getSalesOrder(0,10,"default")
        .then(response => {
          this.items = response.data.data.content;
          // comment console console.log(this.items);
        })
        .catch(error => {
          // comment console console.log(error);
        });
    }
    // returnStatus(idPayment){
    //   SalesOrderService.checkStatus(idPayment)
    //   .then(response => {
    //     var json = response.data;
    //     this.status =  json.transaction_status;
    //   }).catch(error => {
    //     // comment console console.log(error)
    //   });
    // }
  }
};
</script>